import { useCurrentUser } from '@/auth/AuthProvider';

/**
 * 事業実施者の選択可否。漁協ユーザーは自組織固定（変更不可）、基金は選択式。
 */
export function useOperatorScope(): { isFund: boolean; isCoop: boolean; fixedOperatorId: number | null } {
  const me = useCurrentUser();
  const isCoop = me.organizationType === '漁協';
  return { isFund: me.organizationType === '基金', isCoop, fixedOperatorId: isCoop && me.businessOperatorId != null ? Number(me.businessOperatorId) : null };
}
